import axios from 'axios'
import getIpClient from './getIpClient'
import getPageData from './getPageData'
import nameCityToCode from './nameCityToCode'
import {API_GEO_IP} from "../consts/api";

function _calcDistance(latIn, lonIn, latOut, lonOut) {

  let d2r = 0.017453292519943295769236;

  let dLong = (lonOut - lonIn) * d2r;
  let dLat = (latOut - latIn) * d2r;

  let tempSin = Math.sin(dLat / 2.0);
  let tempCos = Math.cos(latIn * d2r);
  let tempSin2 = Math.sin(dLong / 2.0);

  let a = (tempSin * tempSin) + (tempCos * tempCos) * (tempSin2 * tempSin2);

  return 2.0 * Math.atan2(Math.sqrt(a), Math.sqrt(1.0 - a));
}

export default async function () {
  try {
    const ipUser = await getIpClient();
    const pageData = await getPageData();

    const geoIpApi = await axios.get(API_GEO_IP(ipUser));

    const { cityInfo } = pageData;

    const leanList = cityInfo.map(val => {

      let latitude = val.endereco.coordenada.lat;
      let longitude = val.endereco.coordenada.lon;

      let cityKey = nameCityToCode(val.nomeCidade);

      return { cityKey, latitude, longitude }

    });

    const { latitude, longitude } = geoIpApi.data;

    const distanceList = leanList.map(v => {

      let cityKey = v.cityKey;

      let latCity = v.latitude;
      let lonCity = v.longitude;

      let distance = _calcDistance(latitude, longitude, latCity, lonCity);

      return { cityKey, distance}
    });

    distanceList.sort((a, b) => {
      return a.distance - b.distance;
    });

    return distanceList[0].cityKey

  }catch (e) {
    throw e
  }
}
